<template>
  <div class="picking_page">
    <b-breadcrumb :items="breadCrumbs" />
    <div class="row" v-if="order">
      <div class="col-lg-6 col-md-6 col-12">
        <shopify-shipping-details
          :order="order"
          ref="shippingDetails"
        ></shopify-shipping-details>
        <shopify-order-details :order="order"></shopify-order-details>
      </div>
      <div class="col-lg-6 col-md-6 col-12">
        <shopify-picking-utility
          :order="order"
          :order-id="this.$route.params.id"
          ref="picking"
        ></shopify-picking-utility>
      </div>
    </div>
  </div>
</template>

<script>
import ShopifyPickingUtility from "@/components/picking/ShopifyPickingUtility.vue";
import ShopifyShippingDetails from "@/components/picking/ShopifyShippingDetails.vue";
import ShopifyOrderDetails from "@/components/picking/ShopifyOrderDetails.vue";

export default {
  name: "shopify-picking",
  components: {
    ShopifyPickingUtility,
    ShopifyShippingDetails,
    ShopifyOrderDetails
  },
  data() {
    return {
      order: null,
      breadCrumbs: [
        { text: "Dashboard", to: { name: "dashboard" } },
        { text: "Orders", to: { name: "orders" } },
        { text: "Picking", active: true }
      ]
    };
  },
  mounted: function() {
    this.getPickingOrder("picking");
  },
  methods: {
    getPickingOrder(source) {
      let loader = this.$loading.show();
      this.$http
        .get(
          this.APIURL + this.BRAND + "/order-picking/" + this.$route.params.id
        )
        .then(
          response => {
            this.order = response.data;
            console.log(this.order.complete);
            // if (this.order.item_missing_from_stock) {
            //   setTimeout(() => {
            //     this.$refs.picking.error =
            //       "Not all items on this order exist in stock / or stock is lower than needed";
            //   }, 100);
            // } else {
            //   setTimeout(() => {
            //     this.$refs.picking.getNextItemToPick();
            //     //TODO
            //     if (source == "picking") {
            //       this.$refs.picking.printPickingNote();
            //       this.$refs.picking.$refs.model.focus();
            //     }
            //   }, 100);
            // }
            loader.hide();
          },
          error => {
            this.loading = false;
            loader.hide();
            console.log(error);
          }
        );
    }
  }
};
</script>
